import { configureStore } from "@reduxjs/toolkit";
import authReducer from './authSlice';
import tooltipsReducer from './tooltipsSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        tooltips: tooltipsReducer,
    }
})